import React from "react";

import Select from "components/Input/Select";

import classes from "./styles.module.scss";

const TableHeader = ({ filters, setFilters, userTotalCredits }) => {
    return (
        <div className={classes.tableHeaderContainer}>
            <div className={classes.tableHeaderWrapper}>
                <div className={classes.filterSection}>
                    <span className={classes.sortByLabel}>Sort by: </span>
                    <Select
                        className={classes.sortBySelect}
                        options={[
                            { value: "time", label: "Time" },
                            { value: "amount", label: "Amount" },
                            { value: "type", label: "Type" },
                        ]}
                        input={{
                            value: filters.sortBy.value,
                            onChange: (value) =>
                                setFilters({
                                    ...filters,
                                    sortBy: {
                                        value,
                                        label: value.charAt(0).toUpperCase() + value.slice(1),
                                    },
                                }),
                        }}
                        inputStyles={{
                            backgroundColor: "transparent",
                            border: "none",
                            boxShadow: "none",
                            gap: "10px",
                            padding: "0",
                        }}
                        dropDownWidth="120px"
                    />
                </div>
                <div className={classes.balanceContainer}>
                    <span>Current balance</span>
                    <span>{userTotalCredits}</span>
                </div>
            </div>
        </div>
    );
};

export default TableHeader;
